import "./Project.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ResearchOverview from "./sections/ResearchOverview";
import FeaturedFlats from "./sections/FeaturedFlats";
import Footer from "@/reusable_sections/Footer";
export default function ProjectPage() {
  return <div>
      <Header />
      <Hero />
      <ResearchOverview />
      <FeaturedFlats />
      <Footer />
    </div>;
}